import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { NotificationService } from '@core/services/notification.service';
import { WebSocketService } from '@core/services/websocket.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { NotificationListComponent } from '../notification-list/notification-list.component';

@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.component.html',
  standalone: true,
  imports: [CommonModule, NotificationListComponent],
  styleUrls: ['./notification-bell.component.scss'],
})
export class NotificationBellComponent implements OnInit, OnDestroy {
  private readonly notificationService = inject(NotificationService);
  private readonly wsService = inject(WebSocketService);
  private readonly destroy$ = new Subject<void>();

  unreadCount$!: Observable<number>;
  connectionStatusClass = 'disconnected';
  isDropdownOpen = false;

  ngOnInit() {
    this.unreadCount$ = this.notificationService.unreadCount$;

    // S'abonner au statut de connexion WebSocket
    this.wsService.connectionStatus$.pipe(takeUntil(this.destroy$)).subscribe((status) => {
      this.connectionStatusClass =
        status === 'CONNECTED'
          ? 'connected'
          : status === 'CONNECTING' || status === 'RECONNECTING'
            ? 'connecting'
            : 'disconnected';
    });
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
